import { useCallback, useEffect, useState, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useGlobalSpinnerActionsContext } from "./../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "./../../../Context/LanguageContext";
import {
  useAMGSelectedContext,
  useSearchQueryContext,
  useSearchQueryActionContext,
  usePageSizeContext,
  usePageSizeActionContext,
  useCurrentPageContext,
  useCurrentPageActionContext,
  useMainGridSortContext,
  useMainGridSortActionContext,
  useSelectedFunContext,
} from "./../../../Context/GlobalContext";

import Paginator from "./../../Pagging/Paginator";
import _ from "lodash";
import equipmentGroupConstants from "./../../../Constants/EquipmentGroupConstants";
import equipmentGroupActions from "./../../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "./../../../Stores/EquipmentGroupStore";
import { useSelectedConfigActionContext } from "./../../../Context/GlobalContext";
import GridTable from "../../ReusableComponent/GridTable/GridTable";
import HeaderBar from "../../ReusableComponent/Header/HeaderBar";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";
import GridColumn_SettingActions from "../../../Actions/GridColumn_SettingActions";
import GridColumnSettingControl from "../../FilterOptions/GridColumnSettingControl";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import {
  useSelectedFilterActionsContext,
  useSelectedFilterContext,
  useItemSelectedFilterActionsContext,
  useItemSelectedFilterContext,
} from "../../../Context/GridEquipListContext";
import { equipmentClick } from "../Equipment Selected/EquipmentClick";
import MessageBox from "../../MessageBox/MessageBox";

import OrderHistroy from "./OrderHistroy";
import { toast } from "react-toastify";

const AuftraegeUebersicht = ({ fonctionsname, fonctionid }) => {
  //--context
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const selectedAnlageG = useAMGSelectedContext();

  const selectedFilter = useSelectedFilterContext();
  const updateSelectedFilter = useSelectedFilterActionsContext();

  const itemSelectedFilter = useItemSelectedFilterContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();

  const searchQuery = useSearchQueryContext();
  const UpdateSearchQuery = useSearchQueryActionContext();

  const pageSize = usePageSizeContext();
  const currentPage = useCurrentPageContext();

  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdatePageSize = usePageSizeActionContext();

  const sortBy = useMainGridSortContext();
  const UpdateSortBy = useMainGridSortActionContext();
  const selectedFuncId = useSelectedFunContext();
  const updateSelectedConfig = useSelectedConfigActionContext();
  //----variable deklaration
  const navigate = useNavigate();
  const [renderMe, setRenderMe] = useState(null);
  const [tbody, setTbody] = useState(null);

  const [data, setData] = useState(null);

  const isMountedRef = useRef(null);
  const [refresh, setRefresh] = useState(0);

  const [columns, setColumns] = useState(null);
  const [clearfilter, setClearFilter] = useState(false);
  const [exportData, setExportData] = useState(null);

  const [ResponseMsg, setResponseMsg] = useState(null);
  const [exportSuccess, setExportSuccess] = useState(null);

  const [classname, setClassname] = useState(null);
  const [renderSaveMsg, setRenderSaveMsg] = useState(null);

  const [openSearchBox, setOpenSearchBox] = useState(false);
  const [disabledSavedFilter, setDisabledSavedFilter] = useState(false);
  const [tableData, setTableData] = useState({
    data: [],
    headerName: [],
    headers: {},
    filterName: [],
  });
  const [gridAction, setGridAction] = useState({
    actionName: [],
    functionHandler: "",
  });
  const [paginatorData, setpaginatorData] = useState({
    pageCount: "",
    pageSize: "",
    firstRowOnPage: "",
    lastRowOnPage: "",
    rowCount: "",
    rowLength: 0,
  });
  const [_orginalResponse, set_orginalResponse] = useState([]);
  const [renderTable, setRenderTable] = useState("");
  const headerBarControl = {
    clientFilter: true,
    filter: true,
    actionList: true,
    isPaginator: true,
  };
  const [dropValueToHeader, setDropValueToHeader] = useState([]);
  const [tablefunctions, setTablefunctions] = useState(null);
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxText, setMessageBoxText] = useState({});
  const [msgButtons, setMsgButtons] = useState([]);
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const [orderHistroy, setOrderHistroy] = useState(false);
  const [equipmentID, setEquipmentID] = useState("");
  const currentPageRef = useRef();
  currentPageRef.current = currentPage;
  const reportCode = "OrdersOView";
  //-----------------

  const openSearchBoxEvent = (e) => {
    e.preventDefault();
    setOpenSearchBox(true);
  };

  const closeMsg = () => {
    setOpenSearchBox(false);
    setMessageBoxOpen(false);
  };

  const loadData = () => {
    if (sortBy.key !== "") {
      const FilterId = selectedFilter.length > 0 ? selectedFilter[0].id : null;
      if (itemSelectedFilter.length == 0) {
        setClearFilter(true);
      }
      equipmentGroupActions.getEquipmentList2(
        reportCode,
        sortBy.order,
        selectedAnlageG,
        parseInt(currentPage),
        parseInt(pageSize),
        sortBy.key,
        FilterId,
        itemSelectedFilter,
      );

      GridColumn_SettingActions.getSaveFilterList(selectedAnlageG, reportCode);
    }
  };

  // fetch data start ---
  const fetchData = useCallback(() => {
    // var eqGid = selectedAnlageG !== null && selectedAnlageG !== undefined ? selectedAnlageG : sessionStorage.getItem("eqGId");
    if (selectedAnlageG !== null && selectedAnlageG !== undefined) {
      setGlobalSpinner(true);
      loadData();
    }
  }, [selectedAnlageG, searchQuery, pageSize, currentPage, sortBy]);
  // fetch data end ----------

  //manage the sort function
  const requestSort = (key) => {
    UpdateSortBy(key);
  };

  const ExportEvent = (value) => {
    setGlobalSpinner(true);
    setMessageBoxOpen(false);
    const FilterId = selectedFilter.length > 0 ? selectedFilter[0].id : null;
    const buildOption = value;
    equipmentGroupActions.getExportDaten(
      selectedAnlageG,
      buildOption,
      itemSelectedFilter,
      reportCode,
      FilterId,
    );
  };

  const ExportOhneBilderEvent = () => {
    ExportEvent("none");
  };

  const downloadEvent = () => {
    setMessageBoxText({
      title: localization.exportTitle,
      msg: localization.exportMsg1 + "\r\n" + localization.exportMsgNb,
      anlageID: 0,
    });

    setMsgButtons([
      { title: localization.cancelbutton, func: closeMsg },
      { title: localization.ok, func: ExportOhneBilderEvent },
    ]);
    setMessageBoxOpen(true);
  };

  const handleDropDownSelChange = (item) => {
    if (item !== "") {
      GridColumn_SettingActions.getSaveFilterValue(item, reportCode);
    }

    if (currentPage !== 1) {
      UpdateCurrentPage(1);
    } else {
      UpdateSortBy("InventarNr");
    }
  };
  /**-----------------------------------------listner filter value on FilterID Start---------------------------------------*/
  useEffect(() => {
    function getSaveFilterValueSuccess() {
      var res = gridColSettingStore.getSavedFilterValueOrderOverViewResult();
      if (res.length > 0) {
        updateListSelectedFilter(res);
      } else {
        updateListSelectedFilter([]);
        setGlobalSpinner(false);
      }
    }

    function getSaveFilterValueFailure() {
      setGlobalSpinner(false);
      updateListSelectedFilter([]);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_SUCCESS,
      getSaveFilterValueSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_FAILURE,
      getSaveFilterValueFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_SUCCESS,
        getSaveFilterValueSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_FAILURE,
        getSaveFilterValueFailure,
      );
    };
  }, []);

  /**-----------------------------------------listner filter value on FilterID End---------------------------------------*/

  useEffect(() => {
    isMountedRef.current = true;

    if (isMountedRef.current && selectedFuncId == 4) {
      fetchData();
    }

    return () => (isMountedRef.current = false);
  }, [fetchData]);

  useEffect(() => {
    function updateData() {
      var _details = equipmentGroupStore.getEquipmentOrderOverviewListGrid();
      setData(_details);
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_SUCCESS,
      updateData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_SUCCESS,
        updateData,
      );
    };
  }, []);

  //
  useEffect(() => {
    function updateData() {
      setData(null);
      setResponseMsg(localization.LoadFailure);
      setExportSuccess(false);
      setGlobalSpinner(false);
      updateSelectedConfig("");
    }

    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_FAILURE,
      updateData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_FAILURE,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getOderOverViewExport();
      setExportData(tmp);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_ORDEROVERVIEW_SUCCESS,
      updatData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_ORDEROVERVIEW_SUCCESS,
        updatData,
      );
    };
  }, []);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getOderOverViewExport();
      toast.error(tmp);
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_ORDEROVERVIEW_FAILURE,
      updatData,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_ORDEROVERVIEW_FAILURE,
        updatData,
      );

      setResponseMsg(null);
      setExportSuccess(null);
    };
  }, []);

  useEffect(() => {
    if (exportData !== null && exportData !== undefined) {
      // const blob = new Blob(["\ufeff"+ exportData.data], {
      //   type: 'application/vnd.openxmlformats-officedocument.spreadheetml.sheet'
      //   //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      // });
      const url = window.URL.createObjectURL(exportData);

      let a = document.createElement("a");

      a.hidden = "";
      a.href = url;
      a.download = localization.orders + ".xlsx"; //'Export.xlsx';
      a.click();
      setGlobalSpinner(false);
    }

    return () => {};
  }, [exportData]);

  //reload page after some change
  useEffect(() => {
    if (refresh === 1) {
      setGlobalSpinner(true);
      loadData();
    }

    return () => {
      setRefresh(0);
    };
  }, [refresh]);

  useEffect(() => {
    let _renderMe = null;
    if (data !== null && data !== undefined) {
      let headerName = [];
      let _header = data.headers;
      let _rows = data.rows;
      let _idPos;
      let _action = data.actions;
      _header.map((item) => {
        headerName.push(item.name);
      });
      headerName.map((item, index) => {
        if (item === "ID") {
          _idPos = index;
        }
      });
      setGridAction({
        actionName: _action,
        functionHandler: handleFunctionCall,
      });
      const _page = data.pagingInfo;
      const _last = (_page.currentPage - 1) * _page.pageSize + data.rows.length;
      const _first = (_page.currentPage - 1) * _page.pageSize + 1;
      setColumns(data.filters);
      set_orginalResponse({
        data: _rows,
        headerName: headerName,
        headers: _header,
        sortBy: sortBy,
        _idPos: _idPos,
      });
      setTableData({
        data: _rows,
        headerName: headerName, //body.results,
        headers: _header,
        sortBy: sortBy,
      });
      setpaginatorData({
        pageCount: data.pagingInfo.pageCount,
        lastRowOnPage: _last,
        firstRowOnPage: _first,
        rowCount: data.pagingInfo.rowCount,
        pageSize: data.pagingInfo.pageSize,
        func1: UpdateCurrentPage,
        func2: UpdatePageSize,
        activePage: data.pagingInfo.currentPage,
        rowLength: data.rows.length,
      });
      setShowSearchDialog(false);
    } else {
      setShowSearchDialog(true);
    }
    setRenderMe(_renderMe);

    return () => {
      setRenderMe(null);
    };
  }, [data]);

  useEffect(() => {
    function getEquipListSaveFilterSuccess() {
      var res = gridColSettingStore.getOrderViewEquListOnFilterResult();
      if (res) {
        setData(res);
      }
      setGlobalSpinner(false);
    }

    function getEquipListSaveFilterFailure() {
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_EQUI_LIST_ON_ORDER_OVERVIEW_SUCCESS,
      getEquipListSaveFilterSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_EQUI_LIST_ON_ORDER_OVERVIEW_FAILURE,
      getEquipListSaveFilterFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_EQUI_LIST_ON_ORDER_OVERVIEW_SUCCESS,
        getEquipListSaveFilterSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_EQUI_LIST_ON_ORDER_OVERVIEW_FAILURE,
        getEquipListSaveFilterFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getDelSaveFilterResultSuccess() {
      var res = gridColSettingStore.getorderViewDelResult();
      updateSelectedFilter("");
      updateListSelectedFilter([]);
      toast.success(localization.delSuccess);
      if (currentPageRef.current != 1) {
        UpdateCurrentPage(1);
      } else {
        UpdateSortBy("InventarNr");
      }
      setGlobalSpinner(false);
    }

    function getDelSaveFilterResultFailure() {
      const res = gridColSettingStore.getorderViewDelResult();
      toast.success(localization.delSuccess);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_ORDER_OVERVIEW_SUCCESS,
      getDelSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.DEL_SAVED_FILTER_ORDER_OVERVIEW_FAILURE,
      getDelSaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_ORDER_OVERVIEW_SUCCESS,
        getDelSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.DEL_SAVED_FILTER_ORDER_OVERVIEW_FAILURE,
        getDelSaveFilterResultFailure,
      );
    };
  }, []);
  useEffect(() => {
    const _renderTable = (
      <GridTable
        data={tableData}
        handleAction={handleAction}
        requestSort={requestSort}
      />
    );
    setRenderTable(_renderTable);
  }, [tableData]);

  useEffect(() => {
    let _tbody = null;
    if (renderMe !== null && renderMe !== undefined) {
      _tbody = renderMe;
    } else {
      _tbody = (
        <tr key="spinner-0">
          <td colSpan="7">
            {" "}
            <div role="status" style={{ textAlign: "center" }}>
              {localization.isLoading}
            </div>
          </td>
        </tr>
      );
    }

    setTbody(_tbody);
  }, [renderMe]);

  useEffect(() => {
    function getColSettingSaveSuccess() {
      var res = gridColSettingStore.getsaveGridSettingOrderOverviewResult();
      if (res) {
        setShowFilterMenu(false);
        toast.success(localization.saveSuccessMsg);
        setClearFilter(true);
        setDropValueToHeader([]);
        updateSelectedFilter("");
        UpdateSortBy("InventarNr");
        setOpenSearchBox(false);
        setDisabledSavedFilter(false);
      }
    }

    function getColSettingSaveFailure() {
      var res = gridColSettingStore.getsaveGridSettingOrderOverviewResult();
      setShowFilterMenu(false);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_ORDER_OVERVIEW_SUCCESS,
      getColSettingSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_ORDER_OVERVIEW_FAILURE,
      getColSettingSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_ORDER_OVERVIEW_SUCCESS,
        getColSettingSaveSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_ORDER_OVERVIEW_FAILURE,
        getColSettingSaveFailure,
      );
    };
  }, []);
  useEffect(() => {
    function getFilterSaveSuccess() {
      var res = gridColSettingStore.getSavedFilterOrderOverViewResult();
      if (res) {
        setShowFilterMenu(false);
        setOpenSearchBox(false);
        setDisabledSavedFilter(false);
        toast.success(localization.filterSave);
        updateSelectedFilter([res]);
        GridColumn_SettingActions.getSaveFilterList(
          res.equipmentGroupId,
          reportCode,
        );
        setDropValueToHeader([]);
      }
    }

    function getFilterSaveFailure() {
      var res = gridColSettingStore.getSavedFilterOrderOverViewResult();
      setShowFilterMenu(false);
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_ORDER_OVERVIEW_SUCCESS,
      getFilterSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_ORDER_OVERVIEW_FAILURE,
      getFilterSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_ORDER_OVERVIEW_SUCCESS,
        getFilterSaveSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_ORDER_OVERVIEW_FAILURE,
        getFilterSaveFailure,
      );
    };
  }, []);
  useEffect(() => {
    let _classname = null;

    if (exportSuccess === null || exportSuccess === undefined) {
      _classname = null;
    } else {
      _classname =
        exportSuccess === true
          ? "container alert alert-success ext-small text-center"
          : "container alert alert-danger ext-small text-center"; //'container text-success' : 'container text-danger';
    }

    setClassname(_classname);
  }, [exportSuccess]);

  useEffect(() => {
    let _renderSaveMsg =
      ResponseMsg === null ? null : (
        <div className={classname}>
          <p className="lead">{ResponseMsg}</p>
        </div>
      );

    const timeout = setTimeout(() => {
      setRenderSaveMsg(null);
      setResponseMsg(null);
      setExportSuccess(null);
    }, 7000);

    setRenderSaveMsg(_renderSaveMsg);

    return () => {
      clearTimeout(timeout);
    };
  }, [ResponseMsg, , classname]);

  useEffect(() => {
    function getSaveFilterResultSuccess() {
      var res = gridColSettingStore.getsaveFilterListorderOverViewResult();
      if (res.length > 0) {
        setDropValueToHeader(res);
      } else {
        setDropValueToHeader([]);
      }
    }

    function SaveFilterResultFailure() {}

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_SUCCESS,
      getSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_FAILURE,
      SaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_SUCCESS,
        getSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_FAILURE,
        SaveFilterResultFailure,
      );
    };
  }, []);

  function handleAction(actioName, rowselected, headerNameList) {
    const _row = rowselected;
    let id,
      inventarnr,
      eqBez = "";
    headerNameList.map((item, index) => {
      if (item.name.toLowerCase() === "id") {
        id = parseInt(_row[index].value);
      }
      if (item.name.toLowerCase() === "inventarnr") {
        inventarnr = _row[index].value;
      }
      if (item.name.toLowerCase() === "bezeichnung") {
        eqBez = _row[index].value;
      }
    });
    const row = { id: id, inventarnr: inventarnr, bezeichnung: eqBez };
    switch (actioName) {
      case "ViewEquipmentDetails":
        sessionStorage.setItem("eqId", row.id);
        sessionStorage.setItem("invnr", row.inventarnr);
        const path = equipmentClick(row, fonctionid, fonctionsname);
        navigate(path);
      case "History":
        setEquipmentID(row.id);
        setOrderHistroy(true);
    }
  }
  function handleCloseFilterModal() {
    setShowFilterMenu(false);
  }

  function handleFilterMenu() {
    setGlobalSpinner(true);
    setShowFilterMenu(true);
  }

  function handleFunctionCall(e, functionName) {
    switch (functionName) {
      case "DataConfiguration":
        handleFilterMenu();
        break;
      case "ExcelExport":
        downloadEvent(e);
        break;
    }
  }

  function handleFilterLocal(filterResult) {
    setTableData({
      data: filterResult,
      headerName: _orginalResponse.headerName, //body.results,
      headers: _orginalResponse.headers,
      sortBy: sortBy,
    });
  }

  function deleteSaveFilter(filterId) {
    setGlobalSpinner(true);
    GridColumn_SettingActions.deleteSavedFilter(filterId, reportCode);
  }

  function resetClearFilter() {
    setClearFilter(false);
  }

  function handleClosePopOver() {
    setOrderHistroy(false);
  }
  return (
    <div className="container-fluid" id="content">
      <div>
        <h3 className="page-header" style={{ fontWeight: "bold" }}>
          {sessionStorage.getItem("plant") + " " + " / "}
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "")}
            to={"/equipmentGrpEqiupment"}
            onClick={() => {
              UpdateSearchQuery(null);
              UpdateSortBy(null);
            }}
          >
            {sessionStorage.getItem("eqBez")}
          </NavLink>
          {" " + " / " + "  " + fonctionsname}{" "}
        </h3>

        <div className="row">
          <div className="col-5"></div>
          <div className="col-4">
            <div style={{ textAlign: "center" }}>{renderSaveMsg}</div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <MessageBox
          isOpen={messageBoxOpen}
          text={messageBoxText}
          functions={msgButtons}
          close={closeMsg}
        />
        <HeaderBar
          headerBarControl={headerBarControl}
          paginationStates={openSearchBoxEvent}
          paginatorData={paginatorData}
          dropValueToHeader={dropValueToHeader}
          tablefunctions={tablefunctions}
          _orginalResponse={_orginalResponse}
          handleFilterLocal={handleFilterLocal}
          disabledSavedFilter={disabledSavedFilter}
          gridAction={gridAction}
          handleDropDownSelChange={handleDropDownSelChange}
          deleteSaveFilter={deleteSaveFilter}
          showSearchDialog={showSearchDialog}
          resetClearFilter={resetClearFilter}
        />
        <div className="table-responsive px-3 table-height">{renderTable}</div>
        {headerBarControl.isPaginator && (
          <Paginator
            pageCount={paginatorData.pageCount}
            activePage={paginatorData.activePage}
            setCurrentPage={paginatorData.func1}
            rowCount={paginatorData.rowCount}
            pageSize={paginatorData.pageSize}
            setPageSize={paginatorData.func2}
            firstRowOnPage={paginatorData.firstRowOnPage}
            lastRowOnPage={paginatorData.lastRowOnPage}
          />
        )}
        {showFilterMenu && (
          <GridColumnSettingControl
            handleCloseModel={handleCloseFilterModal}
            pageId={reportCode}
          />
        )}
        {orderHistroy && (
          <OrderHistroy
            isorderHistroy={orderHistroy}
            equipmentID={equipmentID}
            handleClosePopOver={handleClosePopOver}
          />
        )}
      </div>
    </div>
  );
};
export default AuftraegeUebersicht;
